export interface InitNotificationParams {
  name: string;
  token: string;
}

export interface UpdateDeviceStatusParams {
  name: string;
  status: "ACTIVE" | "INACTIVE";
  callback?: () => void;
}

export interface getListNotificationParams {
  limit?: number;
  offset?: number;
  sort: string;
  type?: string[];
}

export const ReadStatus = {
  READ: "DA_DOC",
  UNREAD: "CHUA_DOC",
};

export type IReadStatus = keyof typeof ReadStatus;
export interface INotification {
  id: number;
  title: string;
  content: string;
  readStatus: IReadStatus;
  noticeType: number;
  createdAt: string;
  objectId: string;
}

export interface UpdateNotificationStatusParams {
  id: number;
  readStatus: IReadStatus;
}
